import { render, staticRenderFns } from "./KouzuiKikikuruLayer.vue?vue&type=template&id=c472c31c&"
import script from "./KouzuiKikikuruLayer.vue?vue&type=script&lang=js&"
export * from "./KouzuiKikikuruLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports